import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/reverine/reverineMainFeed.jpg'
import logo from '../../../assets/reverine/reverineLogo.jpg'

import interior1 from '../../../assets/reverine/interior-1.png'
import interior2 from '../../../assets/reverine/interior-2.png'
import interior3 from '../../../assets/reverine/interior-3.png'
import interior4 from '../../../assets/reverine/interior-4.png'
import interior5 from '../../../assets/reverine/interior-5.png'

import ameneties1 from '../../../assets/reverine/ameneties-1.png'
import ameneties2 from '../../../assets/reverine/ameneties-2.png'
import ameneties3 from '../../../assets/reverine/ameneties-3.png'
import ameneties4 from '../../../assets/reverine/ameneties-4.png'
import ameneties5 from '../../../assets/reverine/ameneties-5.png'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const Reverine = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const interiors = [interior1, interior2, interior3, interior4, interior5]
    const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Godrej Riverine is an exclusive luxury residential project by Godrej Properties, located in the prime Sector 44 of Noida. This project is inspired by the journey of a river, symbolizing grace, harmony, and continuous growth. Here’s a detailed overview:
                            </p>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Location:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Situated in Sector 44, Noida, Godrej Riverine offers seamless connectivity to major landmarks such as the DND Flyway, Noida Golf Course, and business hubs. It is just 1.4 km from the Botanical Garden Metro Station and 28.5 km from IGI Airport.                                    </p>
                                </div>

                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Design and Layout:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Spread across 6.46 acres, the project features 4-5 iconic towers with 23 floors, housing meticulously designed 3 BHK + Utility and 4 BHK + Utility apartments.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Amenities :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project boasts a range of luxury amenities, including a grand clubhouse, landscaped gardens, swimming pools, fitness centers, outdoor sports courts, and a dedicated children’s play area.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Environment :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Surrounded by lush greenery and thoughtfully landscaped gardens, the project offers a serene and tranquil living experience.                                        </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Architecture :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The design reflects modern refinement, with spacious layouts, premium interiors, and state-of-the-art facilities tailored for an elite lifestyle.
                                    </p>
                                </div>
                            </section>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Highlights :</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Luxury Living:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The apartments are designed to cater to the discerning tastes of urban dwellers, offering breathtaking views and an exquisite lifestyle.
                                    </p>                                </div>

                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Connectivity :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Its strategic location ensures excellent access to Delhi and other parts of the NCR, making it a prime address for residents and businesses.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Reputation  :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Backed by the legacy of Godrej Properties, known for innovation, sustainability, and customer satisfaction.                                    </p>
                                </div>
                            </section>

                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                This project is a testament to Godrej Properties' commitment to quality and excellence, offering a harmonious blend of nature and modern living. If you’re considering a luxurious and serene lifestyle, Godrej Riverine might just be the perfect choice!                            </p>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && activeImageType === "ameneties" && (
                    <ImageModal
                        images={ameneties}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "ameneties")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 mx-4">
                Luxury  Insights
            </h2>
            {openImgModal && activeImageType === "interiors" && (
                <ImageModal
                    images={interiors}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {interiors.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index, "interiors")}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img
                            src={data}
                            alt="ATS"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
export default Reverine